module.exports = __webpack_public_path__ + "static/media/Distrito-03.56fe5708.png";